<ev-page-header />
<main class="open">
  @switch (state()) {
    @case ('preparing') {
      <div class="open__status" role="status">
        <i aria-hidden="true" class="pi pi-spin pi-spinner open__icon"></i>
        <span class="open__heading">{{ labels.preparing }}</span>
        <span class="open__hint">{{ labels.preparingHint }}</span>
      </div>
    }
    @case ('opened') {
      <div class="open__status" role="status">
        <i aria-hidden="true" class="pi pi-check-circle open__icon"></i>
        <span class="open__heading">{{ labels.opened }}</span>
        <button class="open__action" type="button" (click)="openAgain()">
          {{ labels.openAgain }}
        </button>
        <a class="open__action" [routerLink]="['/', token()]">
          {{ labels.backToList }}
        </a>
      </div>
    }
    @case ('unavailable') {
      <div class="open__status" role="alert">
        <i aria-hidden="true" class="pi pi-ban open__icon"></i>
        <span class="open__heading">{{ labels.unavailable }}</span>
      </div>
    }
    @case ('rate-limited') {
      <div class="open__status" role="alert">
        <i aria-hidden="true" class="pi pi-clock open__icon"></i>
        <span class="open__heading">{{ labels.rateLimited }}</span>
        <button class="open__action" type="button" (click)="prepare()">
          {{ labels.retry }}
        </button>
      </div>
    }
    @case ('timed-out') {
      <div class="open__status" role="alert">
        <i aria-hidden="true" class="pi pi-clock open__icon"></i>
        <span class="open__heading">{{ labels.timedOut }}</span>
        <button class="open__action" type="button" (click)="prepare()">
          {{ labels.retry }}
        </button>
      </div>
    }
    @default {
      <div class="open__status" role="alert">
        <i aria-hidden="true" class="pi pi-exclamation-circle open__icon"></i>
        <span class="open__heading">{{ labels.failed }}</span>
        <button class="open__action" type="button" (click)="prepare()">
          {{ labels.retry }}
        </button>
      </div>
    }
  }
</main>
